<template>
  <div class="SectionSearchPanel">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row>
          <v-col>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label for="sectionType">{{ $t("sectionType") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="sectionType"
                          :items="sectionTypes"
                          :label="$t('sectionType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeSectionType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  props: { accessTo: [String, Number] },
  data() {
    return {
      //accessTo: 1,
      requestTypes: [],
      requestType: "",

      sectionType: "",
      sectionTypes: [],
    };
  },
  mounted() {
    this.getSectionModels();
  },

  methods: {
    async getSectionModels() {
      if (EosUtils.isWebKartAdmin()) {
        this.getAllSection();
      } else if (this.accessTo) {
        this.getSectionWithPermissionNumber();
      } else {
        this.getSectionTypes();
      }
    },
    getAllSection() {
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "-1" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        }
      });
    },
    async getSectionTypes() {
      var IsFreeOfGroupManager = false;
      await this.$store.dispatch("IsFreeOfGroupManager").then((result) => {
        if (result.type === ResultType.success) {
          IsFreeOfGroupManager = result.data;
        }
      });

      if (IsFreeOfGroupManager) {
        this.$store.dispatch("sections/GetAllSections").then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            this.search();
          }
        });
      } else {
        this.$store
          .dispatch("sections/GetDedicatedSectionForPersentPessonel")
          .then((result) => {
            ////console.log(result);
            if (result.type == ResultType.success) {
              this.sectionTypes.push(...result.data);
              if (this.sectionTypes.length > 0) {
                this.sectionType = this.sectionTypes[0];
              }

              this.search();
            }
          });
      }
    },

    async getSectionWithPermissionNumber() {
      var params = new URLSearchParams();
      params.append("accessTo", this.accessTo);

      this.$store.dispatch("sections/GetSectionsList", { params }).then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        }
      });
    },

    changeSectionType() {
      this.search();
    },
    search() {
      var searchParams = {
        sectionCode: this.sectionType?.Code?.toString().trim() || "-1",
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}
</style>